<template>
  <div class="modal-bg">
    <div class="modal add-item">
      <i @click="close" class="i-close" />
      <div class="title">Criar</div>
      <div class="options">
        <div
          class="opt"
          :class="{ selected: 'content' === selected }"
          @click="select('content')"
        >
          <i class="i-pages"></i><span>Conteúdo</span>
        </div>
        <div
          class="opt"
          :class="{ selected: 'list' === selected }"
          @click="select('list')"
        >
          <i class="i-menus"></i><span>Lista</span>
        </div>
        <div
          class="opt"
          :class="{ selected: 'faq' === selected }"
          @click="select('faq')"
        >
          <i class="i-fields"></i><span>FAQ</span>
        </div>
        <div
          v-if="$store.getters.app === 'cmp'"
          class="opt"
          :class="{ selected: 'landing' === selected }"
          @click="select('landing')"
        >
          <i class="i-menus"></i><span>Landing</span>
        </div>
      </div>
      <div v-if="selected === 'content'">
        <SimpleSelect
          :label="'Tipo'"
          :allowSearch="true"
          @select-data-value="value = $event"
          :options="
            allTypes.map((t) => {
              return {
                label: t.languages.name
                  ? t.languages.name
                  : t.languages[0].name,
                value: t.id,
                checked: value == t.id,
              };
            })
          "
          :key="1"
        />
      </div>
      <div
        :class="selected"
        v-else-if="
          selected === 'faq' || selected === 'list' || selected === 'landing'
        "
      >
        <div>
          <fyi-text
            :icon_box="false"
            :label="'Nome'"
            @input-text="value = $event"
          />
          <fyi-text
            v-if="selected === 'landing'"
            :icon_box="false"
            :label="'Email do Remetente'"
            @input-text="address_value = $event"
          />
          <fyi-text
            v-if="selected === 'landing'"
            :icon_box="false"
            :label="'Nome do Remetente'"
            @input-text="name_value = $event"
          />
          <fyi-text
            v-if="selected === 'landing'"
            :icon_box="false"
            :label="'Assunto'"
            @input-text="subject = $event"
          />
          <fyi-text
            v-if="selected === 'landing'"
            :icon_box="false"
            :label="'Email destinatário'"
            @input-text="to_value = $event"
          />
        </div>
        <draggable
          v-if="selected === 'landing'"
          v-model="landingBlocks"
          :class="'block-order'"
        >
          <template v-slot:item="{ item }">
            <label>{{ item.name }}</label>
          </template>
        </draggable>
      </div>
      <fyi-button
        :label="'Criar'"
        :className="'default'"
        :disabled="value === null || value === ''"
        :loading="creating"
        :onclick="
          () => {
            create();
          }
        "
      />
    </div>
  </div>
  <teleport to="body">
    <Toast v-if="toast_show" :type="toast_type" :message="toast_message" />
  </teleport>
</template>

<script>
import { mapActions } from "vuex";
import Draggable from "vue3-draggable";

export default {
  name: "AddItemModal",
  components: {
    Draggable,
  },
  data: () => ({
    creating: false,
    allTypes: null,
    selected: null,
    value: null,
    address_value: null,
    name_value: null,
    to_value: null,
    subject: null,
    toast_type: "",
    toast_message: "",
    toast_show: false,
    landingBlocks: [
      { id: "superior", name: "Bloco Superior" },
      { id: "speakers", name: "Oradores" },
      { id: "sponsors", name: "Patrocinadores" },
      { id: "program", name: "Programa" },
      { id: "inferior", name: "Bloco Inferior" },
      { id: "form", name: "Formulário" },
    ],
  }),
  props: {
    types: {
      type: Array,
      default: null,
    },
  },
  beforeMount() {
    this.allTypes = this.types;
  },
  methods: {
    ...mapActions([
      "createType",
      "createBlock",
      "getTypes",
      "createNotification",
    ]),
    close() {
      this.$parent.addItemModal = false;
    },
    select(item) {
      this.value = null;
      this.selected = item;
    },
    async create() {
      this.creating = true;
      if (
        this.selected === "content" &&
        this.value !== null &&
        this.value !== ""
      ) {
        this.$router.push({
          name: "pages_cms_create",
          query: { id: this.value },
        });
      } else if (this.value !== null && this.value !== "") {
        if (this.selected === "faq") {
          await this.createFAQ();
        } else if (this.selected === "landing") {
          await this.createLanding();
        } else {
          await this.createList();
        }
        this.toast_type = "success";
        this.toast_message = "Criado com sucesso.";
        this.toast_show = true;

        this.allTypes = await this.getTypes({});

        this.selected = null;
        this.value = null;
        this.creating = false;
        location.reload();
      }
    },
    async createFAQ() {
      // create type
      let type = {
        languages: [
          {
            name: this.value,
            language_id: 1,
          },
        ],
        addons: ["attachment"],
        page_template: 100,
      };
      const response = await this.createType(type);

      //create content block
      const data_2 = {
        name: this.value + " List",
        data: {
          contents_order: "date_desc",
          contents_limit: 0,
          types: [response.id],
          contents: [],
          url_dependence_limit: null,
          fields: [
            { field: "imageBg", options: "", orderfield: 1 },
            { field: "name", options: "", orderfield: 2 },
          ],
        },
        roles: [0],
        templates: [
          {
            template_id: 100,
            position: "content",
            orderposition: "2",
            plugin: "accordion",
          },
          {
            template_id: 200,
            position: "content",
            orderposition: "2",
            plugin: "accordion",
          },
        ],
        pages: [{ page: "type_" + response.id, language_id: 1, show: true }],
        type: "content",
        published: 1,
      };
      await this.createBlock({ data: data_2 });
    },
    async createList() {
      // create type
      let type = {
        languages: [
          {
            name: this.value,
            language_id: 1,
          },
        ],
        addons: ["attachment"],
        page_template: 100,
        contents_template: 200,
      };
      const response = await this.createType(type);

      //create text block
      const data_1 = {
        name: this.value + " List Title",
        data: [{ language_id: 1, text: this.value, type: "html" }],
        roles: [0],
        templates: [
          {
            template_id: 100,
            position: "content",
            orderposition: "1",
            plugin: "html",
          },
          {
            template_id: 200,
            position: "content",
            orderposition: "2",
            plugin: "html",
          },
        ],
        pages: [
          {
            page: "type_" + response.id,
            language_id: 1,
            show: true,
          },
        ],
        type: "text",
        published: 1,
      };

      //create content block
      await this.createBlock({ data: data_1 });
      const data_2 = {
        name: this.value + " List",
        data: {
          contents_order: "date_desc",
          contents_limit: 0,
          types: [response.id],
          contents: [],
          url_dependence_limit: null,
          fields: [
            { field: "imageBg", options: "", orderfield: 1 },
            { field: "name", options: "", orderfield: 2 },
          ],
        },
        roles: [0],
        templates: [
          {
            template_id: 100,
            position: "content",
            orderposition: "2",
            plugin: "grid",
          },
          {
            template_id: 200,
            position: "content",
            orderposition: "3",
            plugin: "grid",
          },
        ],
        pages: [{ page: "type_" + response.id, language_id: 1, show: true }],
        type: "content",
        published: 1,
        create_default_content: true,
      };
      await this.createBlock({ data: data_2 });

      // create breadcrumb
      if (this.$store.getters.app === "go-porto") {
        const data_3 = {
          name: this.value + " Breadcrumb",
          data: {
            contents_order: "date_desc",
            contents_limit: 0,
            types: null,
            contents: null,
            url_dependence_limit: 1,
          },
          roles: [0],
          templates: [
            {
              template_id: 200,
              position: "content",
              orderposition: "0",
              plugin: "breadcrumb_simple",
            },
          ],
          pages: [
            {
              page: "type_" + response.id + "_contents",
              language_id: 1,
              show: true,
            },
          ],
          type: "content",
          published: 1,
        };
        await this.createBlock({ data: data_3 });
      }
    },
    async createLanding() {
      // create type
      let type = {
        languages: [
          {
            name: this.value,
            language_id: 1,
          },
        ],
        addons: ["attachment", "event", "field"],
        fields: [
          {
            field_id: 21,
          },
          {
            field_id: 22,
          },
          {
            field_id: 23,
          },
          {
            field_id: 24,
          },
          {
            field_id: 25,
          },
          {
            field_id: 26,
          },
          {
            field_id: 27,
          },
          {
            field_id: 28,
          },
          {
            field_id: 29,
          },
        ],
        config: { typeAsContent: true },
        page_template: 100,
        contents_template: 200,
        parent: 1000,
      };
      const response = await this.createType(type);

      //create content block
      const data_1 = {
        name: this.value + " Bloco Superior",
        data: {
          contents_order: "date_desc",
          contents_limit: 0,
          types: [],
          contents: [],
          url_dependence_limit: 1,
          fields: [
            { field: "event_banner", options: "", orderfield: 1 },
            { field: "event_description", options: "", orderfield: 2 },
            { field: "event_video", options: "", orderfield: 3 },
          ],
        },
        roles: [0],
        templates: [
          {
            template_id: 200,
            position: "content",
            orderposition:
              this.landingBlocks.findIndex((item) => item.id === "superior") +
              1,
            plugin: "info",
          },
        ],
        pages: [
          {
            page: "type_" + response.id + "_contents",
            language_id: 1,
            show: true,
          },
        ],
        type: "content",
        published: 1,
      };
      await this.createBlock({ data: data_1 });

      const data_2 = {
        name: this.value + " Bloco Inferior",
        data: {
          contents_order: "date_desc",
          contents_limit: 0,
          types: [],
          contents: [],
          url_dependence_limit: 1,
          fields: [
            { field: "event_body", options: "", orderfield: 1 },
            { field: "galeria", options: "", orderfield: 2 },
            { field: "arquivo", options: "", orderfield: 3 },
          ],
        },
        roles: [0],
        templates: [
          {
            template_id: 200,
            position: "content",
            orderposition:
              this.landingBlocks.findIndex((item) => item.id === "inferior") +
              1,
            plugin: "info",
          },
        ],
        pages: [
          {
            page: "type_" + response.id + "_contents",
            language_id: 1,
            show: true,
          },
        ],
        translations: [
          {
            key: "galeria",
            data: {
              pt: "Galeria",
            },
          },
        ],
        type: "content",
        published: 1,
      };
      await this.createBlock({ data: data_2 });

      //create speakers block

      let speaker_type = {
        languages: [
          {
            name: this.value + " Speakers",
            language_id: 1,
          },
        ],
        addons: ["attachment"],
        parent: response.id,
      };

      const response_speaker = await this.createType(speaker_type);

      const data_3 = {
        name: this.value + " Speakers",
        data: {
          contents_order: "date_desc",
          contents_limit: 0,
          types: [response_speaker.id],
          contents: [],
          url_dependence_limit: null,
          fields: [
            { field: "imageBg", options: "", orderfield: 1 },
            { field: "name", options: "", orderfield: 2 },
            { field: "description", options: "", orderfield: 3 },
            { field: "body", options: "", orderfield: 4 },
          ],
        },
        roles: [0],
        templates: [
          {
            template_id: 200,
            position: "content",
            orderposition:
              this.landingBlocks.findIndex((item) => item.id === "speakers") +
              1,
            plugin: "speakers",
          },
        ],
        pages: [
          {
            page: "type_" + response.id + "_contents",
            language_id: 1,
            show: true,
          },
        ],
        type: "content",
        published: 1,
      };
      await this.createBlock({ data: data_3 });

      // create program block

      let program_type = {
        languages: [
          {
            name: this.value + " Program",
            language_id: 1,
          },
        ],
        addons: [],
        parent: response.id,
      };

      const response_program = await this.createType(program_type);

      const data_4 = {
        name: this.value + " Program",
        data: {
          contents_order: "date_desc",
          contents_limit: 0,
          types: [response_program.id],
          contents: [],
          url_dependence_limit: null,
          fields: [
            { field: "name", options: "", orderfield: 1 },
            { field: "body", options: "", orderfield: 2 },
          ],
        },
        roles: [0],
        templates: [
          {
            template_id: 200,
            position: "content",
            orderposition:
              this.landingBlocks.findIndex((item) => item.id === "program") + 1,
            plugin: "program",
          },
        ],
        pages: [
          {
            page: "type_" + response.id + "_contents",
            language_id: 1,
            show: true,
          },
        ],
        type: "content",
        published: 1,
      };
      await this.createBlock({ data: data_4 });

      // create sponsors block

      let sponsor_type = {
        languages: [
          {
            name: this.value + " Sponsors",
            language_id: 1,
          },
        ],
        addons: ["attachment"],
        parent: response.id,
      };

      const response_sponsor = await this.createType(sponsor_type);

      const data_5 = {
        name: this.value + " Sponsors",
        data: {
          contents_order: "date_desc",
          contents_limit: 0,
          types: [response_sponsor.id],
          contents: [],
          url_dependence_limit: null,
          fields: [{ field: "image", options: "", orderfield: 1 }],
        },
        roles: [0],
        templates: [
          {
            template_id: 200,
            position: "content",
            orderposition:
              this.landingBlocks.findIndex((item) => item.id === "sponsors") +
              1,
            plugin: "sponsors",
          },
        ],
        pages: [
          {
            page: "type_" + response.id + "_contents",
            language_id: 1,
            show: true,
          },
        ],
        type: "content",
        published: 1,
      };
      await this.createBlock({ data: data_5 });

      //create form block
      let form_type = {
        languages: [
          {
            name: this.value + " Form",
            language_id: 1,
          },
        ],
        addons: ["attachment", "field"],
        fields: [
          {
            field_id: 3,
          },
          {
            field_id: 16,
          },
        ],
        parent: response.id,
      };

      const response_form = await this.createType(form_type);

      const data_6 = {
        name: this.value + " Form",
        data: [
          {
            type_id: response_form.id,
            language_id: 1,
            content_status: "pending",
            fields: [
              {
                field: "name",
                orderfield: 1,
                required: "1",
              },
              {
                field: "field_3",
                orderfield: 2,
                required: "1",
              },
              {
                field: "body",
                orderfield: 3,
                required: "1",
              },
              {
                field: "field_16",
                orderfield: 4,
                required: "1",
              },
            ],
          },
        ],
        roles: [0],
        templates: [
          {
            template_id: 200,
            position: "content",
            orderposition:
              this.landingBlocks.findIndex((item) => item.id === "form") + 1,
            plugin: "form",
          },
        ],
        pages: [
          {
            page: "type_" + response.id + "_contents",
            language_id: 1,
            show: true,
          },
        ],
        translations: [
          {
            key: "name",
            data: {
              pt: "Nome",
            },
          },
          {
            key: "info",
            data: {
              pt: "Campos obrigatórios",
            },
          },
          {
            key: "message",
            data: {
              pt: "Mensagem",
            },
          },
          {
            key: "submit",
            data: {
              pt: "Enviar",
            },
          },
          {
            key: "success_title",
            data: {
              pt: "Sucesso",
            },
          },
          {
            key: "success_description",
            data: {
              pt: "Enviado com sucesso!",
            },
          },
          {
            key: "attachment",
            data: {
              pt: "Anexo",
            },
          },
        ],
        type: "form",
        published: 1,
      };
      await this.createBlock({ data: data_6 });

      // notification

      await this.createNotification({
        api_id: 7,
        app_id: this.$parent.$parent.$parent.app.id,
        action: `${this.$store.getters.app}.cms.content.create.${response_form.id}`,
        name: "Email Notification - " + this.value,
        data: {
          options: {
            template_id: "d-2ca1c6eb16a64a7aa149ab35314f52c5",
            from_address: this.address_value,
            from_name: this.name_value,
            subject: this.subject,
          },
          to: this.to_value.split(","),
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/components/layout/modals";
</style>
